/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { NewsManagementPreviewNewsResponse } from './NewsManagementPreviewNewsResponse';

export type NewsManagementPreviewNewsResponseApiRespoonse = {
    data?: NewsManagementPreviewNewsResponse;
    status?: NewsManagementPreviewNewsResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace NewsManagementPreviewNewsResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

